module.exports = __webpack_public_path__ + "img/CRIT_AIR_1.afdb47cc.png";